<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">Rental Detail {{schoolname}} </h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <label><b>Year</b></label>
                                <select class="form-control" #YearID="ngModel" ngModel name="YearID"
                                     [(ngModel)]="yearid" (change)="getRentalDetailList()" required>
                                    <option *ngFor="let year of yearlist" [value]="year.value"
                                        [selected]="yearid == year.value">
                                        {{ year.text }}
                                    </option>
                                </select>            
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="table-responsive subject">
                                    <div>
                                        <div class="card col-mb-6 mt-2">
                                            <div class="card-header py-3">
                                                <input type="text" class="form-control bg-white border-0 small"
                                                    placeholder="Search for..." [(ngModel)]="searchtext"
                                                    aria-label="Search" aria-describedby="basic-addon2"
                                                    (keyup)="setpage()" />
                                            </div>
                                        </div>
                                        <table id="example" class="table table-striped table-bordered"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. No.</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('RelationWithOwner')">Relation with land/building owner</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('YearlyRentAmountBuilding')">Rent of building </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('YearlyRentAmountPlayGround')">Rent of playgroud</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('DurationOfRentDeed')">Duration of rent deed</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('DateOfRentDeed')"> Date of rent deed execution</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('LastThreeYearRentAmount')">Amount of rent paid in last three years</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('BankName')">Name of bank </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('Branch')">Branch</th>
                                                    <th class="pointer" scope="col" (click)="sortBy('AccountHolderName')"> Name of account holder </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('AccountNumber')"> Account number</th>
                                                    <th class="pointer" scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="rentalDetailList != undefined && rentalDetailList.length != 0">
                                                <tr
                                                    *ngFor="let r of rentalDetailList | filter:searchtext | paginate: { itemsPerPage: pageLimit, currentPage: p };let i = index">
                                                    <td>{{r.SrNo}}</td>
                                                    <td><p>{{r.RelationWithOwner}}</p></td>
                                                    <td><p>{{r.YearlyRentAmountBuilding}}</p></td>
                                                    <td><p>{{r.YearlyRentAmountPlayGround}}</p></td>
                                                    <td><p>{{r.DurationOfRentDeed}}</p></td>
                                                    <td><p>{{r.DateOfRentDeed}}</p></td>
                                                    <td><p>{{r.LastThreeYearRentAmount}}</p></td>
                                                    <td><p>{{r.BankName}}</p></td>
                                                    <td><p>{{r.Branch}}</p></td>
                                                    <td><p>{{r.AccountHolderName}}</p></td>
                                                    <td><p>{{r.AccountNumber}}</p></td>
                                                    <td>&nbsp; <button type="button" class="btn btn-danger" (click)="deleteRentalDetail(r.HashCode)">Delete</button></td>
                                                </tr>
                                            </tbody>
                                            <tbody *ngIf="rentalDetailList == undefined || rentalDetailList.length == 0">
                                                <tr>
                                                    <td colspan="12" style="text-align: center;"> No Record Found </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div *ngIf="rentalDetailList != undefined && rentalDetailList.length != 0" class="card-footer pb-0 pt-3" align="right">
                                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>